import React from "react";
import { Link } from "react-router-dom";
import styles from "./Logo.module.css";

const Logo = () => {
  return (
    <div className={styles.logo}>
      <Link to="/home">
        {/* <span>SHARE TO WEAR</span> */}
        <div className="max-w-[180px]">
          <img src="/images/Asset.png" />
        </div>
      </Link>
    </div>
  );
};

export default Logo;
